/**
 * RTWO Native Currency Engine — Null Ledger Adapter
 */

import type { CurrencyId, PolicyId } from '../domain-models';
import type { ILedgerAdapter, LedgerAdapterStatus } from './ledger-adapter-interface';

export class NullLedgerAdapter implements ILedgerAdapter {
  readonly adapterId = 'null-ledger-adapter';
  readonly adapterName = 'Null Ledger Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): LedgerAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async querySupplyState(_currencyId: CurrencyId) {
    return null;
  }

  async configureMonetaryPolicy(
    _currencyId: CurrencyId,
    _supplyModel: string,
    _issuancePolicy: string,
    _burnPolicy: string,
    _inflationPolicy: string,
    _deflationPolicy: string
  ) {
    return null;
  }

  async configureAllocationPolicy(
    _currencyId: CurrencyId,
    _allocationType: string,
    _allocationReference: string,
    _vestingPolicyReference: string
  ) {
    return null;
  }

  async configureEmissionSchedule(
    _currencyId: CurrencyId,
    _emissionType: string,
    _emissionReference: string,
    _startReference: string,
    _endReference: string
  ) {
    return null;
  }

  async validateCurrency(_currencyId: CurrencyId) {
    return null;
  }

  async validateMonetaryPolicy(_policyId: PolicyId) {
    return null;
  }
}
